'use strict';

const { h } = require('phy');
const { getButtonUrl } = require('../../modules/support/slug-helper');

function LeaderboardBanner({
  imageUrl,
  advert: { leaderboard, merchantSlug, destination },
  outerClassName = '',
  routes,
}) {
  const buttonUrl = getButtonUrl({
    routes,
    merchantSlug,
    destination,
  });

  const {
    leaderboardTextColour,
    title,
    leaderboardButtonColour,
    leaderboardButtonText,
  } = leaderboard;

  return h(
    `.leaderboard-banner.${outerClassName}`,
    {
      'data-bhw': 'leaderboard-banner',
    },
    h(
      '.banner-content',
      {
        style: {
          'background-image': `url(${imageUrl})`,
        },
      },
      h(
        '.banner-title',
        {
          style: {
            color: `#${leaderboardTextColour}`,
          },
        },
        title
      ),
      h(
        'a.btn.btn-transparent.banner-button',
        {
          href: buttonUrl,
          style: {
            color: `#${leaderboardButtonColour}`,
          },
        },
        leaderboardButtonText
      )
    )
  );
}

module.exports = LeaderboardBanner;
